import React, { useCallback } from 'react';
import { Button, Icon, Modal } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../Localization';
import { useAuditLogs, ExportFormat, VisibleColumnsConfig } from '../../../Contexts/AuditLogsContext';

type AuditLogsExportModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  visibleColumns?: VisibleColumnsConfig;
}

export const AuditLogsExportModal: React.FC<AuditLogsExportModalProps> = ({
  open,
  setOpen,
  visibleColumns
}) => {
  const L = useLocalizedStrings();
  const { initiateExport, isExporting } = useAuditLogs();

  const handleExport = useCallback(async (format: ExportFormat) => {
    // Close the modal immediately
    setOpen(false);

    // Initiate the export - the page will handle toast notifications
    try {
      await initiateExport({
        format,
        visibleColumns
      });
    } catch (error) {
      console.error('Failed to initiate export:', error);
    }
  }, [visibleColumns, initiateExport, setOpen]);

  const handleExportCSV = () => handleExport('csv');
  const handleExportXLSX = () => handleExport('xlsx');

  return (
    <Modal title={L.admin_panel.audit_logs.export} open={open} onClose={() => setOpen(false)}>
      <div className="pb-4">
        {L.admin_panel.payments.export_recipients_desc}
      </div>
      <div className="flex flex-col gap-y-2">
        <Button
          onClick={handleExportCSV}
          variant="secondary"
          className="!justify-start"
          isDisabled={isExporting}
        >
          <div className="flex gap-4 items-center py-2">
            <Icon name="ArrowDownTrayIcon" role='decorative'/>
            <div className="!text-left">
              <div>{L.admin_panel.payments.csv_format}</div>
              <div className="font-light">{L.admin_panel.payments.csv_format_desc}</div>
            </div>
          </div>
        </Button>
        <Button
          onClick={handleExportXLSX}
          variant="secondary"
          className="!justify-start"
          isDisabled={isExporting}
        >
          <div className="flex gap-4 items-center py-2">
            <Icon name="TableCellsIcon" role='decorative'/>
            <div className="!text-left">
              <div>{L.admin_panel.payments.xlsx_format}</div>
              <div className="font-light">{L.admin_panel.payments.xlsx_format_desc}</div>
            </div>
          </div>
        </Button>
      </div>
    </Modal>
  );
};

export default AuditLogsExportModal;
